module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


// WEBPACK FOOTER //
// ../node_modules/babel-runtime/core-js/object/assign.js